class TestFileSubmissionModalController {
    constructor(TestFileSubmissionServiceApi, toastr) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.state = {
                showSpinner: true,
                noFilesAvailable: false,
                testerId: this.resolve.testerId,
                simId: this.resolve.simId,
                files: [],
                selectedFile: null
            };
            this.TestFileSubmissionServiceApi.getTestFiles(this.state.simId, this.state.testerId)
                .then((response) => {
                this.state.files = response.data.Files;
                if (!this.state.files) {
                    this.state.noFilesAvailable = true;
                    return;
                }
                this.state.selectedFile = response.data.Files[0];
            })
                .catch((error) => {
                this.toastr.error('Error retrieving files from simulator');
            }).finally(() => {
                this.state.showSpinner = false;
            });
        };
        this.submit = () => {
            this.state.showSpinner = true;
            this.TestFileSubmissionServiceApi.triggerTestCases(this.state.simId, this.state.selectedFile.Uid, this.state.testerId)
                .then((response) => {
                if (response.data > 0) {
                    this.toastr.info(`${response.data} test cases executing...`);
                }
                else {
                    this.toastr.warning(`${this.state.selectedFile.Name} has no matching test cases`);
                }
                this.cancel();
            }).catch((error) => {
                this.state.showSpinner = false;
                this.toastr.error('Error submitting file to simulator');
            });
        };
        this.cancel = () => {
            this.dismiss();
        };
        this.TestFileSubmissionServiceApi = TestFileSubmissionServiceApi;
        this.toastr = toastr;
    }
}
angular.module('app').component('testFileSubmissionModal', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/TestExecution/ProjectTesting/TestFileSubmissionModal/test-file-submission-modal.tpl.html',
    controllerAs: 'vm',
    controller: TestFileSubmissionModalController
});
